import React from "react";
import "./styles/footer.scss";

function Footer() {
  return (
    <footer id="footer">
      <div className="footer-content">
        <p className="footer-brand font-brand">Made by Pratyush</p>
        <p className="footer-copy font-mono">
          © {new Date().getFullYear()} Pratyush Kumar Rai · Bangalore, India
        </p>
      </div>
    </footer>
  );
}

export default Footer;
